import React, { useEffect, useState } from "react";
import '../../Styles/Purchaseorder.css';
import FormField from "../../../component/formFiedl";
import { PostCallWithErrorResponse, simpleGetCallWithErrorResponse } from "../../../api/ApiServices";
import ApiConfig from "../../../api/ApiConfig";
import { forEach } from "lodash";
import { ToastMsg } from "../../TostMsg";
import dele from '../../../assets/images/delete.svg'
import Loader from "../../Loader";
import { ClipLoader } from "react-spinners";

const orderTypes = [
    {
        label: 'Standard',
        value: 'Standard'
    },
    {
        label: 'Urgent',
        value: 'Urgent'
    },
    {
        label: 'Backorder',
        value: 'Backorder'
    },
]


const fields = ['Item', 'HSN', 'Qty', 'Unit', 'Price', 'GST %', "Total"];
const LineItemRow = () => (

    <div className="line-item-row">
        {fields.map((field) => (
            <div key={field} className="line-field d-flex">
                <strong><label className="line-label">{field}</label></strong>
                <input
                    type="text"
                    placeholder={field}
                    className="line-input"
                />

            </div>
        ))}
    </div>
);

const Procurement = () => {

    const initialOrder = {
        "Id": 0,
        "PONumber": '',
        "VendorId": '',
        "VendorName": "",
        "BillingAddress": "",
        "WarehouseId": '',
        "WarehouseName": "",
        "PODate": "",
        "VendorGSTIN": "",
        "ShippingAddress": "",
        "OrderType": "",
        "TotalAmount": 0,
        "IsActive": true,

    }



    const initialPopDetails = [
        {
            "Id": 0,
            "POHeaderId": 0,
            "ItemId": 0,
            "ItemName": "",
            "HSN": "",
            "Qty": '',
            "Unit": "",
            "Price": "",
            "GSTPercent": "",
            "Total": ''
        }
    ]

    const [isValided, setIsValided] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const [vendorList, setVendorList] = useState([])
    const [wareHouses, setwareHouses] = useState([])
    const [orderDetails, setOrderDetails] = useState(initialOrder)
    const [popDetails, setPopDetails] = useState(initialPopDetails)

    const [errorMsg, setErrorMsg] = useState({})

    const handleChange = (key, value) => {

        setOrderDetails(prev => ({
            ...prev,
            [key]: value
        }))

    }

    const getVendors = () => {

        simpleGetCallWithErrorResponse(ApiConfig?.GET_VENOR_CUSTOMER + 'Vendor').then((res) => {

            if (res?.json?.success) {
                setVendorList(res?.json?.data)
            }


        })

    }

    const getWarehouses = () => {

        simpleGetCallWithErrorResponse(ApiConfig?.GET_WAREHOUSES).then((res) => {
            if (res?.json?.success) {
                setwareHouses(res?.json?.data)
            }
        })

    }

    useEffect(() => {

        getVendors()
        getWarehouses()

    }, [])

    const handleAdd = () => {

        setPopDetails(prev => ([...prev, {
            "Id": 0,
            "POHeaderId": 0,
            "ItemId": 0,
            "ItemName": "",
            "HSN": "",
            "Qty": "",
            "Unit": "",
            "Price": '',
            "GSTPercent": '',
            "Total": ''
        }]))

    }

    const handleDelete = (index) => {

        let filt = popDetails?.filter((_, indx) => indx != index)

        setPopDetails(filt)

    }

    const handleInputChange = (index, field, value) => {
        const updatedDetails = [...popDetails];
        updatedDetails[index][field] = value;

        if (field === "Qty" || field === "Price" || field === "GSTPercent") {
            const qty = parseFloat(updatedDetails[index].Qty) || 0;
            const price = parseFloat(updatedDetails[index].Price) || 0;
            const gst = parseFloat(updatedDetails[index].GSTPercent) || 0;
            const total = qty * price + (qty * price * gst) / 100;
            updatedDetails[index].Total = Number(total.toFixed(2));
        }

        setPopDetails(updatedDetails);
    };

    const handleSubmit = () => {

        if (isLoading) return

        let isValided = false

        setErrorMsg(prev => ({
            ...prev,
            VendorId: !orderDetails?.VendorId ? "Please Select VEndor Name" : "",
            BillingAddress: !orderDetails?.BillingAddress ? 'Please Enter Billing Address' : "",
            WarehouseId: !orderDetails?.WarehouseId ? "Please Select Warehouse" : "",
            ShippingAddress: !orderDetails?.ShippingAddress ? "Please Enter Ship Address" : "",
            OrderType: !orderDetails?.OrderType ? "Please Select Order Type" : "",
            PODate: !orderDetails?.PODate ? "Please Select Date" : "",
            VendorGSTIN: !orderDetails?.VendorGSTIN ? 'Please Enter GST Number' : ""
        }))

        let total = 0;
        for (let item of popDetails) {
            if (
                !item.ItemName ||
                !item.HSN ||
                !item.Qty ||
                !item.Unit ||
                !item.Price ||
                !item.GSTPercent
            ) {
                setIsValided(true);
                ToastMsg('error', 'Please fill all item fields');
                isValided = true;
                break;
            }

            total += Number(item?.Total)
        }


        if (!orderDetails?.VendorId || !orderDetails?.BillingAddress || !orderDetails?.WarehouseId
            || !orderDetails?.ShippingAddress || !orderDetails?.OrderType || !orderDetails?.PODate ||
            !orderDetails?.VendorGSTIN || isValided

        ) {
            return
        }
        orderDetails.TotalAmount = total
        let payload = {
            PODetails: popDetails,
            POHeader: orderDetails,

        }

        setIsLoading(true)

        PostCallWithErrorResponse(ApiConfig.CREATE_PURCHASE_ORDER, JSON.stringify(payload)).then((res) => {
            if (res?.json?.success) {
                ToastMsg('success', res?.json?.message)
                setPopDetails(initialPopDetails)
                setOrderDetails(initialOrder)
            } else {
                ToastMsg('error', res?.json?.message)
            }
            setIsLoading(false)
            setIsValided(false)
        })


    }


    return (
        <div className="purchase-order-form">
            <div className="card">
                <h2>Create Purchase Order</h2>

                <div className="form-grid">
                    <FormField placeholder="PO Number (Auto-generated)"
                        value={orderDetails?.PONumber}
                        onChange={(key, value) => {


                            handleChange(key, value)
                        }}
                        valKey={'PONumber'}
                        validationErr={errorMsg?.PONumber}

                    />
                    <FormField type="date" value={orderDetails?.PODate}

                        onChange={(key, value) => {


                            handleChange(key, value)
                        }}
                        validationErr={errorMsg?.PODate}
                        valKey={'PODate'}
                    />
                    <FormField placeholder="Vendor Name" type='select'
                        value={orderDetails?.VendorId}

                        onChange={(key, value) => {

                            let vendor = vendorList?.filter((val) => val.id == value)[0]
                            handleChange('VendorId', Number(value) || '')
                            handleChange('VendorGSTIN', vendor?.billGstNo)
                            handleChange('BillingAddress', vendor?.billAddr)
                            handleChange('ShippingAddress', vendor?.shipAddr)
                        }}
                        valKey={"VendorId"}
                        validationErr={errorMsg?.VendorId}
                        options={vendorList}
                        valueKey={'id'}
                        labelKey={'billCustName'}
                    />
                    <FormField placeholder="Vendor GSTIN" value={orderDetails?.VendorGSTIN}
                        onChange={(key, value) => {


                            handleChange(key, value)
                        }}
                        validationErr={errorMsg?.VendorGSTIN}
                        valKey={'VendorGSTIN'}
                    />
                    <FormField placeholder="Billing Address" value={orderDetails?.BillingAddress}
                        onChange={(key, value) => {


                            handleChange(key, value)
                        }}
                        valKey={'BillingAddress'}
                        validationErr={errorMsg?.BillingAddress}
                    />
                    <FormField placeholder="Shipping Address" value={orderDetails?.ShippingAddress}
                        onChange={(key, value) => {

                            handleChange(key, value)
                        }}
                        validationErr={errorMsg?.ShippingAddress}
                        valKey={'ShippingAddress'}
                    />
                    <FormField placeholder="Warehouse" type="select" value={orderDetails?.WarehouseId}
                        onChange={(key, value) => {



                            let warehouse = wareHouses?.filter((val) => val.id == value)[0]

                            handleChange("WarehouseId", Number(value) || '')
                            handleChange("WarehouseName", warehouse?.warehouseName)
                        }}

                        validationErr={errorMsg?.WarehouseId}
                        valKey={'WarehouseId'}
                        options={wareHouses}
                        valueKey={'id'}
                        labelKey={'warehouseName'}
                    />
                    <FormField
                        value={orderDetails?.OrderType}
                        onChange={(key, value) => {


                            handleChange(key, value)
                        }}
                        valKey={'OrderType'}
                        type="select"
                        placeholder="Select Order Type"
                        options={orderTypes}
                        validationErr={errorMsg?.OrderType}
                    />
                </div>

                <div className="line-items">
                    <h3>Line Items</h3>
                    <div className="line-item-row" style={{ marginBottom: '0px' }}>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">Item</label></strong>
                        </div>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">HSN</label></strong>
                        </div>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">QTY</label></strong>
                        </div>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">UNIT</label></strong>
                        </div>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">Price</label></strong>
                        </div>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">GST%</label></strong>
                        </div>
                        <div className="line-field d-flex">
                            <strong><label className="line-label">Total</label></strong>
                        </div>
                        <div className="" style={{ width: "40px" }}></div>

                    </div>
                    {
                        popDetails?.map((item, index) => {
                            return <div className="line-item-row" key={index}>
                                <div className="line-field d-flex">
                                    <input
                                        type="text"
                                        placeholder={'Item'}
                                        className="line-input"
                                        value={item?.ItemName}
                                        onChange={(e) => handleInputChange(index, 'ItemName', e.target.value)}
                                        style={isValided && !item?.ItemName ? { border: "1px solid red" } : {}}
                                    />

                                </div>
                                <div className="line-field d-flex">
                                    <input
                                        type="text"
                                        placeholder={'HSN'}
                                        className="line-input"
                                        value={item?.HSN}
                                        onChange={(e) => handleInputChange(index, 'HSN', e.target.value)}
                                        style={isValided && !item?.HSN ? { border: "1px solid red" } : {}}
                                    />

                                </div>
                                <div className="line-field d-flex">
                                    <input
                                        type="number"
                                        placeholder={'QTY'}
                                        className="line-input"
                                        value={item?.Qty}
                                        onChange={(e) => handleInputChange(index, 'Qty', Number(e.target.value) || '')}
                                        style={isValided && !item?.Qty ? { border: "1px solid red" } : {}}
                                    />

                                </div>
                                <div className="line-field d-flex">
                                    <input
                                        type="text"
                                        placeholder={'Unit'}
                                        className="line-input"
                                        value={item?.Unit}
                                        onChange={(e) => handleInputChange(index, 'Unit', e.target.value)}
                                        style={isValided && !item?.Unit ? { border: "1px solid red" } : {}}
                                    />

                                </div>
                                <div className="line-field d-flex">
                                    <input
                                        type="number"
                                        placeholder={'Price'}
                                        className="line-input"
                                        value={item?.Price}
                                        onChange={(e) => handleInputChange(index, 'Price', Number(e.target.value) || '')}
                                        style={isValided && !item?.Price ? { border: "1px solid red" } : {}}
                                    />

                                </div>
                                <div className="line-field d-flex">
                                    <input
                                        type="number"
                                        placeholder={'GST%'}
                                        className="line-input"
                                        value={item?.GSTPercent}
                                        onChange={(e) => {
                                            if (e.target.value > 100) return
                                            handleInputChange(index, 'GSTPercent', Number(e.target.value) || '')

                                        }}
                                        style={isValided && !item?.GSTPercent ? { border: "1px solid red" } : {}}
                                    />

                                </div>
                                <div className="line-field d-flex">
                                    <input
                                        type="number"
                                        placeholder={'Total'}
                                        className="line-input"
                                        value={item?.Total}
                                        disabled={true}
                                    />

                                </div>
                                <div className="" style={{ width: "40px", marginTop: '5px', cursor: "pointer" }}>
                                    {
                                        popDetails?.length > 1 && <img src={dele} alt=""
                                            onClick={() => handleDelete(index)}
                                        />
                                    }

                                </div>

                            </div>
                        })
                    }
                    <div className="form-buttons d-flex" style={{ justifyContent: "end" }}>
                        <button className="btn submit"
                            onClick={handleAdd}
                        >Add Item</button>
                    </div>

                </div>

                <div className="form-buttons d-flex" style={{ justifyContent: "end" }}>
                    {/* <button className="btn draft">Save Draft</button> */}
                    <button className="btn submit"
                        onClick={handleSubmit}
                    >{isLoading ? <ClipLoader size="16" color="white" /> : "Submit Purchase Order"} </button>
                </div>
            </div>
        </div>
    );
};

export default Procurement;
